export default {
  navigate: { $call: 'ui.history.push' },
};

